import { intrinsicClassName } from '../../../utils/reactView';
import styles from './MalfunctionQuestion.module.css';

export const MalfunctionItem = intrinsicClassName(
  'div',
  styles.malfunctionItem
);
export const MalfunctionAccordionTitle = intrinsicClassName(
  'div',
  styles.accordionTitle
);
